import { render, staticRenderFns } from "./About.vue?vue&type=template&id=44347351&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=44347351&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44347351",
  null
  
)

export default component.exports